module.exports = __webpack_public_path__ + "img/5.57990478.png";